import React, { useState } from "react";
import styled from "styled-components";
import { useAuth } from "../../context/AuthContext";
import { enrollInModule, trackEvent } from "../../lib/elearning";

const Inline = styled.div`
  display: inline-flex;
  @media (max-width: 767px) { display: none; }
`;

const Sticky = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: flex;
    position: fixed;
    left: 0; right: 0; bottom: 0;
    background: var(--nd-black);
    border-top: 1px solid var(--nd-border-visible);
    padding: 12px 16px;
    z-index: 80;
    gap: 12px;
    align-items: center;
  }
`;

const Button = styled.button`
  font-family: 'Space Mono', monospace;
  font-size: 13px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: var(--nd-accent);
  color: var(--nd-text-display);
  border: none;
  border-radius: 999px;
  padding: 14px 24px;
  min-height: 44px;
  cursor: pointer;
  flex: 1;
  transition: opacity 250ms cubic-bezier(0.25, 0.1, 0.25, 1);
  &:hover:not(:disabled) { opacity: 0.85; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const Status = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  color: var(--nd-success);
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

const useEnroll = (moduleId, moduleTitle) => {
  const { user, signIn } = useAuth();
  const [state, setState] = useState("idle"); // idle | busy | done | error
  const onClick = async () => {
    if (!user) { signIn().catch(() => {}); return; }
    setState("busy");
    try {
      await enrollInModule({ uid: user.uid, moduleId, moduleTitle });
      trackEvent("enroll_clicked", { module_id: moduleId });
      setState("done");
    } catch {
      setState("error");
    }
  };
  return { state, onClick, user };
};

const Label = ({ state, user }) => {
  if (state === "busy") return "Enrolling…";
  if (state === "done") return "Enrolled";
  if (state === "error") return "Try again";
  return user ? "Enroll" : "Sign in to enroll";
};

const EnrollCta = ({ moduleId, moduleTitle }) => {
  const { state, onClick, user } = useEnroll(moduleId, moduleTitle);
  return (
    <>
      <Inline>
        <Button type="button" onClick={onClick} disabled={state === "busy" || state === "done"}>
          <Label state={state} user={user} />
        </Button>
      </Inline>
      <Sticky>
        {state === "done" && <Status>Enrolled</Status>}
        <Button type="button" onClick={onClick} disabled={state === "busy" || state === "done"}>
          <Label state={state} user={user} />
        </Button>
      </Sticky>
    </>
  );
};

export default EnrollCta;
